export interface SupplierContact {
  id: string;
  titleId: string;
  title: string;
  forename: string;
  surname: string;
  tel: string;
  fax: string;
  mob: string;
  ext: string;
  email: string;
  position: string;
  supplierId: string;
}
